export interface Code {
  id?: string
  name?: LangString
  description?: LangString
  type?: CodeType
  defaultKey?: string
  values?: CodeValue[]
  permission?: Permission
  edit?: Edit
}

export interface CodeValue {
  code?: string
  value?: LangString
  equivalence?: string[]
  description?: LangString
  url?: string
  detail?: boolean
  system?: string[]
}

export type CodeType =
  'SYSTEM' |
  'USER'
export const CODE_TYPE_DEF: EnumDef = Object.freeze({
  id: 'jps-code_type',
  c: {
    SYSTEM: {
      l: {},
      d: {}
    },
    USER: {
      l: {},
      d: {}
    }
  }
})
export const CODE_CONTENTS_ACCESS: Code = Object.freeze({
  id: 'jps-contents_access',
  name: {
    ja: 'デジタルコンテンツ公開状況',
    en: 'Access to Digital Contents'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'internet',
      value: {
        ja: 'ウェブ公開',
        en: 'Web'
      }
    },
    {
      code: 'restricted',
      value: {
        ja: '限定公開',
        en: 'Restricted'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'restricted',
      value: {
        ja: 'NDL館内限定公開',
        en: 'Available only at the NDL'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'not_exist',
      value: {
        ja: 'デジタルコンテンツなし',
        en: 'Not Exist'
      }
    },
    {
      code: 'various',
      value: {
        ja: 'コンテンツによってアクセス可能性が異なる',
        en: 'Accessibility is different in each content'
      }
    }
  ]
})
export const CODE_CURATION_TOPIC_CATEGORY: Code = Object.freeze({
  id: 'jps-curation_topic_category',
  name: {
    ja: 'トピックカテゴリ',
    en: 'Topic Category'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'person',
      value: {
        ja: '人',
        en: 'Person'
      }
    },
    {
      code: 'organization',
      value: {
        ja: '組織',
        en: 'Organication'
      }
    },
    {
      code: 'work',
      value: {
        ja: '作品',
        en: 'Work'
      }
    },
    {
      code: 'artifact',
      value: {
        ja: 'もの',
        en: 'Artifact'
      }
    },
    {
      code: 'event',
      value: {
        ja: '出来事',
        en: 'Event'
      }
    },
    {
      code: 'Architecture',
      value: {
        ja: '建築物',
        en: 'Architecture'
      }
    },
    {
      code: 'natural',
      value: {
        ja: '自然物',
        en: 'Natural Objects'
      }
    },
    {
      code: 'location',
      value: {
        ja: '地名',
        en: 'Location'
      }
    }
  ]
})
export const CODE_DB_CATEGORY: Code = Object.freeze({
  id: 'jps-db_category',
  name: {
    ja: 'データベースカテゴリ',
    en: 'Database Category'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'anime',
      value: {
        ja: 'アニメ',
        en: 'Animation'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'movie',
      value: {
        ja: '映画',
        en: 'Movie'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'game',
      value: {
        ja: 'ゲーム',
        en: 'Game'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'official',
      value: {
        ja: '公文書',
        en: 'Official Document'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'science',
      value: {
        ja: '自然史・理工学',
        en: 'Natural Hostory/Engineering Science'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'book',
      value: {
        ja: '書籍等',
        en: 'Book/Publication'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'humanities',
      value: {
        ja: '人文学',
        en: 'Humanities'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'regional',
      value: {
        ja: '地域',
        en: 'Regional Resource'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'map',
      value: {
        ja: '地図',
        en: 'Map'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'dataset',
      value: {
        ja: 'データセット',
        en: 'Dataset'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'art',
      value: {
        ja: '美術',
        en: 'Art'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'pfart',
      value: {
        ja: '舞台芸術',
        en: 'Performing Art'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'cultural',
      value: {
        ja: '文化財',
        en: 'Cultural Property'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'broadcast',
      value: {
        ja: '放送番組',
        en: 'Broadcast Program'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'manga',
      value: {
        ja: 'マンガ',
        en: 'Manga'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'media',
      value: {
        ja: 'メディアアート',
        en: 'Media Art'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'great_east_japan_earthquake_2011',
      value: {
        ja: '東日本大震災 (2011)',
        en: 'Great East Japan Earthquake (2011)'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'great_hanshin_awaji_earthquake_1995',
      value: {
        ja: '阪神・淡路大震災 (1995)',
        en: 'Great Hanshin-Awaji Earthquake (1995)'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'chuetsu_earthquake_2004',
      value: {
        ja: '新潟県中越地震 (2004)',
        en: 'Chuetsu Earthquake (2004)'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'kumamoto_earthquakes_2016',
      value: {
        ja: '熊本地震 (2016)',
        en: 'Kumamoto Earthquakes (2016)'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'noto_peninsula_earthquake_2024',
      value: {
        ja: '能登半島地震 (2024)',
        en: 'Noto Peninsula Earthquake (2024)'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'other_earthquakes',
      value: {
        ja: 'その他地震',
        en: 'Other Earthquakes'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'accident_at_the_fukushima_daiichi_nuclear_power_station_2011',
      value: {
        ja: '福島第一原発事故 (2011)',
        en: 'Accident at the Fukushima Daiichi Nuclear Power Station (2011)'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'earthquake_preparedness',
      value: {
        ja: '震災への備え',
        en: 'Earthquake Preparedness'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'disaster_situation',
      value: {
        ja: '被災状況',
        en: 'Disaster Situation'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'reconstruction',
      value: {
        ja: '復興',
        en: 'Reconstruction'
      },
      system: [
        'hina'
      ]
    }
  ]
})
export const CODE_DIGITAL_CONTENTS_TYPE: Code = Object.freeze({
  id: 'jps-digital_contents_type',
  name: {
    ja: 'コンテンツフォーマット',
    en: 'Contents Format'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'image',
      value: {
        ja: '画像',
        en: 'Image'
      },
      system: [
        'jps',
        'hina'
      ]
    },
    {
      code: 'video',
      value: {
        ja: '動画',
        en: 'Video'
      },
      system: [
        'jps',
        'hina'
      ]
    },
    {
      code: 'text',
      value: {
        ja: '文書',
        en: 'Text'
      },
      system: [
        'jps',
        'hina'
      ]
    },
    {
      code: 'table',
      value: {
        ja: '表形式',
        en: 'Spreadsheet'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'sound',
      value: {
        ja: '音声',
        en: 'Sound'
      },
      system: [
        'jps',
        'hina'
      ]
    },
    {
      code: '3d',
      value: {
        ja: '3D',
        en: '3D'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'pdf',
      value: {
        ja: 'PDF',
        en: 'PDF'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'website',
      value: {
        ja: 'Webサイト',
        en: 'Website'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'other',
      value: {
        ja: 'その他',
        en: 'Other'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'various',
      value: {
        ja: 'フォーマットはコンテンツによって異なる',
        en: 'Various'
      },
      system: [
        'jps',
        'hina'
      ]
    }
  ]
})
export const CODE_FACET_RIGHTS_TYPE: Code = Object.freeze({
  id: 'jps-facet_rights_type',
  name: {
    ja: '権利区分',
    en: 'Rights Type'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'edu',
      value: {
        ja: '教育利用',
        en: 'Educational'
      },
      equivalence: [
        'cc0',
        'pdm',
        'ccby',
        'ccbysa',
        'ccbync',
        'ccbyncsa',
        'incr_edu'
      ]
    },
    {
      code: 'noncom',
      value: {
        ja: '非商用利用',
        en: 'Non-commercial'
      },
      equivalence: [
        'cc0',
        'pdm',
        'ccby',
        'ccbysa',
        'ccbync',
        'ccbyncsa'
      ]
    },
    {
      code: 'com',
      value: {
        ja: '商用利用',
        en: 'Commercial'
      },
      equivalence: [
        'cc0',
        'pdm',
        'ccby',
        'ccbysa'
      ]
    },
    {
      code: 'cc0',
      value: {
        ja: 'CC0',
        en: 'CC0'
      },
      detail: true
    },
    {
      code: 'pdm',
      value: {
        ja: 'PDM',
        en: 'PDM'
      },
      detail: true
    },
    {
      code: 'ccby',
      value: {
        ja: 'CC BY（表示）',
        en: 'CC BY'
      },
      detail: true
    },
    {
      code: 'ccbysa',
      value: {
        ja: 'CC BY-SA（表示—継承）',
        en: 'CC BY-SA'
      },
      detail: true
    },
    {
      code: 'ccbynd',
      value: {
        ja: 'CC BY-ND（表示—改変禁止）',
        en: 'CC BY-ND'
      },
      detail: true
    },
    {
      code: 'ccbync',
      value: {
        ja: 'CC BY-NC（表示—非営利）',
        en: 'CC BY-NC'
      },
      detail: true
    },
    {
      code: 'ccbyncsa',
      value: {
        ja: 'CC BY-NC-SA（表示—非営利—継承）',
        en: 'CC BY-NC-SA'
      },
      detail: true
    },
    {
      code: 'ccbyncnd',
      value: {
        ja: 'CC BY-NC-ND（表示—非営利—改変禁止）',
        en: 'CC BY-NC-ND'
      },
      detail: true
    },
    {
      code: 'incr',
      value: {
        ja: '著作権あり',
        en: 'IN COPYRIGHT'
      },
      detail: true
    },
    {
      code: 'incr_edu',
      value: {
        ja: '著作権あり-教育目的の利用可',
        en: 'IN COPYRIGHT-EDUCATIONAL USE PERMITTED'
      },
      detail: true
    },
    {
      code: 'nocr_cont',
      value: {
        ja: '著作権なし-契約による制限あり',
        en: 'NO COPYRIGHT-CONTRACTUAL RESTRICTIONS'
      },
      detail: true
    },
    {
      code: 'nocr_other',
      value: {
        ja: '著作権なし-他の法的制限あり',
        en: 'NO COPYRIGHT-OTHER KNOWN LEGAL RESTRICTIONS'
      },
      detail: true
    },
    {
      code: 'uneval',
      value: {
        ja: '著作権未評価',
        en: 'COPYRIGHT NOT EVALUATED'
      },
      detail: true
    },
    {
      code: 'undet',
      value: {
        ja: '著作権未決定-裁定制度利用著作物',
        en: 'COPYRIGHT UNDETERMINED-ORPHAN WORK in JAPAN'
      },
      detail: true
    },
    {
      code: 'others',
      value: {
        ja: '該当なし',
        en: 'Not applicable'
      },
      detail: true
    }
  ]
})
export const CODE_ITEM_API_TYPE: Code = Object.freeze({
  id: 'jps-item_api_type',
  type: 'SYSTEM',
  values: [
    {
      code: 'ok',
      value: {
        ja: 'API取得可能',
        en: 'API Available'
      },
      description: {
        ja: '',
        en: ''
      }
    },
    {
      code: 'restricted',
      value: {
        ja: '一部項目利用不可',
        en: 'Some Fiels Unavailable'
      },
      description: {
        ja: '',
        en: ''
      }
    },
    {
      code: 'ng',
      value: {
        ja: 'API利用不可',
        en: 'API Unavailable'
      },
      description: {
        ja: '',
        en: ''
      }
    }
  ]
})
export const CODE_LANGUAGE: Code = Object.freeze({
  id: 'jps-language',
  name: {
    ja: '言語',
    en: 'Language'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'aar',
      value: {
        ja: 'アファル語',
        en: 'Afar'
      }
    },
    {
      code: 'abk',
      value: {
        ja: 'アブハズ語',
        en: 'Abkhazian'
      }
    },
    {
      code: 'ace',
      value: {
        ja: 'アチェ語',
        en: 'Achinese'
      }
    },
    {
      code: 'ach',
      value: {
        ja: 'アチョリ語',
        en: 'Acoli'
      }
    },
    {
      code: 'ada',
      value: {
        ja: 'アダグメ語',
        en: 'Adangme'
      }
    },
    {
      code: 'ady',
      value: {
        ja: 'アディゲ語',
        en: 'Adyghe; Adygei'
      }
    },
    {
      code: 'afa',
      value: {
        ja: 'アフロ・アジア語族(その他)',
        en: 'Afro-Asiatic languages'
      }
    },
    {
      code: 'afh',
      value: {
        ja: 'アフリヒリ',
        en: 'Afrihili'
      }
    },
    {
      code: 'afr',
      value: {
        ja: 'アフリカーンス語',
        en: 'Afrikaans'
      }
    },
    {
      code: 'ain',
      value: {
        ja: 'アイヌ語',
        en: 'Ainu'
      }
    },
    {
      code: 'aka',
      value: {
        ja: 'アカン語',
        en: 'Akan'
      }
    },
    {
      code: 'akk',
      value: {
        ja: 'アッカド語',
        en: 'Akkadian'
      }
    },
    {
      code: 'alb',
      value: {
        ja: 'アルバニア語',
        en: 'Albanian'
      }
    },
    {
      code: 'sqi',
      value: {
        ja: 'アルバニア語',
        en: ''
      }
    },
    {
      code: 'ale',
      value: {
        ja: 'アリュート語',
        en: 'Aleut'
      }
    },
    {
      code: 'alg',
      value: {
        ja: 'アルゴンキン語族',
        en: 'Algonquian languages'
      }
    },
    {
      code: 'alt',
      value: {
        ja: '南アルタイ語',
        en: 'Southern Altai'
      }
    },
    {
      code: 'amh',
      value: {
        ja: 'アムハラ語',
        en: 'Amharic'
      }
    },
    {
      code: 'ang',
      value: {
        ja: '古英語',
        en: 'English, Old (ca.450-1100)'
      }
    },
    {
      code: 'anp',
      value: {
        ja: 'アンガ語',
        en: 'Angika'
      }
    },
    {
      code: 'apa',
      value: {
        ja: 'アパッチ語族',
        en: 'Apache languages'
      }
    },
    {
      code: 'ara',
      value: {
        ja: 'アラビア語',
        en: 'Arabic'
      }
    },
    {
      code: 'arc',
      value: {
        ja: 'アラム語',
        en: 'Official Aramaic (700-300 BCE); Imperial Aramaic (700-300 BCE)'
      }
    },
    {
      code: 'arg',
      value: {
        ja: 'アラゴン語',
        en: 'Aragonese'
      }
    },
    {
      code: 'arm',
      value: {
        ja: 'アルメニア語',
        en: 'Armenian'
      }
    },
    {
      code: 'hye',
      value: {
        ja: 'アルメニア語',
        en: ''
      }
    },
    {
      code: 'arn',
      value: {
        ja: 'アラウコ語族',
        en: 'Mapudungun; Mapuche'
      }
    },
    {
      code: 'arp',
      value: {
        ja: 'アラパホ語',
        en: 'Arapaho'
      }
    },
    {
      code: 'art',
      value: {
        ja: '人工言語(その他)',
        en: 'Artificial languages'
      }
    },
    {
      code: 'arw',
      value: {
        ja: 'アラワク語族',
        en: 'Arawak'
      }
    },
    {
      code: 'asm',
      value: {
        ja: 'アッサム語',
        en: 'Assamese'
      }
    },
    {
      code: 'ast',
      value: {
        ja: 'アストゥリアス語',
        en: 'Asturian; Bable; Leonese; Asturleonese'
      }
    },
    {
      code: 'ath',
      value: {
        ja: 'アサパスカ語族',
        en: 'Athapascan languages'
      }
    },
    {
      code: 'aus',
      value: {
        ja: 'オーストラリア先住民語',
        en: 'Australian languages'
      }
    },
    {
      code: 'ava',
      value: {
        ja: 'アバール語',
        en: 'Avaric'
      }
    },
    {
      code: 'ave',
      value: {
        ja: 'アベスタ語',
        en: 'Avestan'
      }
    },
    {
      code: 'awa',
      value: {
        ja: 'アワディー語',
        en: 'Awadhi'
      }
    },
    {
      code: 'aym',
      value: {
        ja: 'アイマラ語',
        en: 'Aymara'
      }
    },
    {
      code: 'aze',
      value: {
        ja: 'アゼルバイジャン語',
        en: 'Azerbaijani'
      }
    },
    {
      code: 'bad',
      value: {
        ja: 'バンダ語',
        en: 'Banda languages'
      }
    },
    {
      code: 'bai',
      value: {
        ja: 'バミレケ諸語',
        en: 'Bamileke languages'
      }
    },
    {
      code: 'bak',
      value: {
        ja: 'バシュキール語',
        en: 'Bashkir'
      }
    },
    {
      code: 'bal',
      value: {
        ja: 'バルーチー語',
        en: 'Baluchi'
      }
    },
    {
      code: 'bam',
      value: {
        ja: 'バンバラ語',
        en: 'Bambara'
      }
    },
    {
      code: 'ban',
      value: {
        ja: 'バリ語',
        en: 'Balinese'
      }
    },
    {
      code: 'baq',
      value: {
        ja: 'バスク語',
        en: 'Basque'
      }
    },
    {
      code: 'eus',
      value: {
        ja: 'バスク語',
        en: ''
      }
    },
    {
      code: 'bas',
      value: {
        ja: 'バサ語',
        en: 'Basa'
      }
    },
    {
      code: 'bat',
      value: {
        ja: 'バルト語派(その他)',
        en: 'Baltic languages'
      }
    },
    {
      code: 'bej',
      value: {
        ja: 'ベジャ語',
        en: 'Beja; Bedawiyet'
      }
    },
    {
      code: 'bel',
      value: {
        ja: '白ロシア語/ベラルーシ語',
        en: 'Belarusian'
      }
    },
    {
      code: 'bem',
      value: {
        ja: 'ベンバ語',
        en: 'Bemba'
      }
    },
    {
      code: 'ben',
      value: {
        ja: 'ベンガル語',
        en: 'Bengali'
      }
    },
    {
      code: 'ber',
      value: {
        ja: 'ベルベル語派(その他)',
        en: 'Berber languages'
      }
    },
    {
      code: 'bho',
      value: {
        ja: 'ボージュプリー語',
        en: 'Bhojpuri'
      }
    },
    {
      code: 'bih',
      value: {
        ja: 'ビハール語',
        en: 'Bihari languages'
      }
    },
    {
      code: 'bik',
      value: {
        ja: 'ビコル小語群',
        en: 'Bikol'
      }
    },
    {
      code: 'bin',
      value: {
        ja: 'ビニ語',
        en: 'Bini; Edo'
      }
    },
    {
      code: 'bis',
      value: {
        ja: 'ビスラマ語',
        en: 'Bislama'
      }
    },
    {
      code: 'bla',
      value: {
        ja: 'ブラックフット語',
        en: 'Siksika'
      }
    },
    {
      code: 'bnt',
      value: {
        ja: 'バントゥ諸語(その他)',
        en: 'Bantu (Other)'
      }
    },
    {
      code: 'bos',
      value: {
        ja: 'ボスニア語',
        en: 'Bosnian'
      }
    },
    {
      code: 'bra',
      value: {
        ja: 'ブラジ語',
        en: 'Braj'
      }
    },
    {
      code: 'bre',
      value: {
        ja: 'ブルトン語',
        en: 'Breton'
      }
    },
    {
      code: 'btk',
      value: {
        ja: 'バタク語(インドネシア)',
        en: 'Batak languages'
      }
    },
    {
      code: 'bua',
      value: {
        ja: 'ブリヤート語',
        en: 'Buriat'
      }
    },
    {
      code: 'bug',
      value: {
        ja: 'ブギス語',
        en: 'Buginese'
      }
    },
    {
      code: 'bul',
      value: {
        ja: 'ブルガリア語',
        en: 'Bulgarian'
      }
    },
    {
      code: 'bur',
      value: {
        ja: 'ビルマ語/ミャンマー語',
        en: 'Burmese'
      }
    },
    {
      code: 'mya',
      value: {
        ja: 'ビルマ語/ミャンマー語',
        en: ''
      }
    },
    {
      code: 'byn',
      value: {
        ja: 'ビリン語',
        en: 'Blin; Bilin'
      }
    },
    {
      code: 'cad',
      value: {
        ja: 'カド語',
        en: 'Caddo'
      }
    },
    {
      code: 'cai',
      value: {
        ja: '中米インディアン諸語(その他)',
        en: 'Central American Indian languages'
      }
    },
    {
      code: 'car',
      value: {
        ja: 'カリブ語',
        en: 'Galibi Carib'
      }
    },
    {
      code: 'cat',
      value: {
        ja: 'カタロニア語',
        en: 'Catalan; Valencian'
      }
    },
    {
      code: 'cau',
      value: {
        ja: 'カフカース諸語(その他)',
        en: 'Caucasian languages'
      }
    },
    {
      code: 'ceb',
      value: {
        ja: 'セブアノ語',
        en: 'Cebuano'
      }
    },
    {
      code: 'cel',
      value: {
        ja: 'ケルト語派(その他)',
        en: 'Celtic languages'
      }
    },
    {
      code: 'cha',
      value: {
        ja: 'チャモロ語',
        en: 'Chamorro'
      }
    },
    {
      code: 'chb',
      value: {
        ja: 'チブチャ語族',
        en: 'Chibcha'
      }
    },
    {
      code: 'che',
      value: {
        ja: 'チェチェン語',
        en: 'Chechen'
      }
    },
    {
      code: 'chg',
      value: {
        ja: 'チャガタイ語',
        en: 'Chagatai'
      }
    },
    {
      code: 'chi',
      value: {
        ja: '中国語',
        en: 'Chinese'
      }
    },
    {
      code: 'zho',
      value: {
        ja: '中国語',
        en: ''
      }
    },
    {
      code: 'chk',
      value: {
        ja: 'トラック語',
        en: 'Chuukese'
      }
    },
    {
      code: 'chm',
      value: {
        ja: 'マリ語',
        en: 'Mari'
      }
    },
    {
      code: 'chn',
      value: {
        ja: 'チヌーク・ジャーゴン',
        en: 'Chinook jargon'
      }
    },
    {
      code: 'cho',
      value: {
        ja: 'チョクトー語',
        en: 'Choctaw'
      }
    },
    {
      code: 'chp',
      value: {
        ja: 'チペワイアン語',
        en: 'Chipewyan; Dene Suline'
      }
    },
    {
      code: 'chr',
      value: {
        ja: 'チェロキー語',
        en: 'Cherokee'
      }
    },
    {
      code: 'chu',
      value: {
        ja: '教会スラブ語',
        en: 'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic'
      }
    },
    {
      code: 'chv',
      value: {
        ja: 'チュワシュ語',
        en: 'Chuvash'
      }
    },
    {
      code: 'chy',
      value: {
        ja: 'シャイアン語',
        en: 'Cheyenne'
      }
    },
    {
      code: 'cmc',
      value: {
        ja: 'チャム諸語',
        en: 'Chamic languages'
      }
    },
    {
      code: 'cop',
      value: {
        ja: 'コプト語',
        en: 'Coptic'
      }
    },
    {
      code: 'cor',
      value: {
        ja: 'コーンウォール語',
        en: 'Cornish'
      }
    },
    {
      code: 'cos',
      value: {
        ja: 'コルシカ語',
        en: 'Corsican'
      }
    },
    {
      code: 'cpe',
      value: {
        ja: '英語系クレオル諸語及びピジン語(その他)',
        en: 'Creoles and pidgins, English based'
      }
    },
    {
      code: 'cpf',
      value: {
        ja: 'フランス語系クレオル諸語及びピジン語(その他)',
        en: 'Creoles and pidgins, French-based '
      }
    },
    {
      code: 'cpp',
      value: {
        ja: 'ポルトガル語系クレオル諸語及びピジン語(その他)',
        en: 'Creoles and pidgins, Portuguese-based '
      }
    },
    {
      code: 'cre',
      value: {
        ja: 'クリー語',
        en: 'Cree'
      }
    },
    {
      code: 'crh',
      value: {
        ja: 'クリム・タタール語/クリム・トルコ語',
        en: 'Crimean Tatar; Crimean Turkish'
      }
    },
    {
      code: 'crp',
      value: {
        ja: 'クレオル諸語及びピジン語(その他)',
        en: 'Creoles and pidgins '
      }
    },
    {
      code: 'csb',
      value: {
        ja: 'カシューブ語',
        en: 'Kashubian'
      }
    },
    {
      code: 'cus',
      value: {
        ja: 'クシュ語派(その他)',
        en: 'Cushitic languages'
      }
    },
    {
      code: 'cze',
      value: {
        ja: 'チェコ語',
        en: 'Czech'
      }
    },
    {
      code: 'ces',
      value: {
        ja: 'チェコ語',
        en: ''
      }
    },
    {
      code: 'dak',
      value: {
        ja: 'ダコタ語',
        en: 'Dakota'
      }
    },
    {
      code: 'dan',
      value: {
        ja: 'デンマーク語',
        en: 'Danish'
      }
    },
    {
      code: 'dar',
      value: {
        ja: 'ダルグワ語',
        en: 'Dargwa'
      }
    },
    {
      code: 'day',
      value: {
        ja: 'ダヤク語',
        en: 'Land Dayak languages'
      }
    },
    {
      code: 'del',
      value: {
        ja: 'デラウエア語',
        en: 'Delaware'
      }
    },
    {
      code: 'den',
      value: {
        ja: 'スレイビー語',
        en: 'Slave (Athapascan)'
      }
    },
    {
      code: 'dgr',
      value: {
        ja: 'ドグリブ語',
        en: 'Dogrib'
      }
    },
    {
      code: 'din',
      value: {
        ja: 'ディンカ語',
        en: 'Dinka'
      }
    },
    {
      code: 'div',
      value: {
        ja: 'ディベヒ語/モルジブ語',
        en: 'Divehi; Dhivehi; Maldivian'
      }
    },
    {
      code: 'doi',
      value: {
        ja: 'ドーグリー語',
        en: 'Dogri'
      }
    },
    {
      code: 'dra',
      value: {
        ja: 'ドラビダ語族(その他)',
        en: 'Dravidian languages'
      }
    },
    {
      code: 'dsb',
      value: {
        ja: '下ソルブ語',
        en: 'Lower Sorbian'
      }
    },
    {
      code: 'dua',
      value: {
        ja: 'ドゥアラ語',
        en: 'Duala'
      }
    },
    {
      code: 'dum',
      value: {
        ja: '中期オランダ語',
        en: 'Dutch, Middle (ca.1050-1350)'
      }
    },
    {
      code: 'dut',
      value: {
        ja: 'オランダ語',
        en: 'Dutch; Flemish'
      }
    },
    {
      code: 'nld',
      value: {
        ja: 'オランダ語',
        en: ''
      }
    },
    {
      code: 'dyu',
      value: {
        ja: 'ジュラ語',
        en: 'Dyula'
      }
    },
    {
      code: 'dzo',
      value: {
        ja: 'ゾンカ語/ブータン語',
        en: 'Dzongkha'
      }
    },
    {
      code: 'efi',
      value: {
        ja: 'エフィック語',
        en: 'Efik'
      }
    },
    {
      code: 'egy',
      value: {
        ja: '古代エジプト語',
        en: 'Egyptian (Ancient)'
      }
    },
    {
      code: 'eka',
      value: {
        ja: 'エカジュク語',
        en: 'Ekajuk'
      }
    },
    {
      code: 'elx',
      value: {
        ja: 'エラム語',
        en: 'Elamite'
      }
    },
    {
      code: 'eng',
      value: {
        ja: '英語',
        en: 'English'
      }
    },
    {
      code: 'enm',
      value: {
        ja: '中期英語',
        en: 'English, Middle (1100-1500)'
      }
    },
    {
      code: 'epo',
      value: {
        ja: 'エスペラント語',
        en: 'Esperanto'
      }
    },
    {
      code: 'est',
      value: {
        ja: 'エストニア語',
        en: 'Estonian'
      }
    },
    {
      code: 'ewe',
      value: {
        ja: 'エウェ語群/エベ語群',
        en: 'Ewe'
      }
    },
    {
      code: 'ewo',
      value: {
        ja: 'エウォンド語',
        en: 'Ewondo'
      }
    },
    {
      code: 'fan',
      value: {
        ja: 'ファン語',
        en: 'Fang'
      }
    },
    {
      code: 'fao',
      value: {
        ja: 'フェーロー語',
        en: 'Faroese'
      }
    },
    {
      code: 'fat',
      value: {
        ja: 'ファンテ語',
        en: 'Fanti'
      }
    },
    {
      code: 'fij',
      value: {
        ja: 'フィジー語',
        en: 'Fijian'
      }
    },
    {
      code: 'fil',
      value: {
        ja: 'フィリピノ語/ピリピノ語',
        en: 'Filipino; Pilipino'
      }
    },
    {
      code: 'fin',
      value: {
        ja: 'フィンランド語',
        en: 'Finnish'
      }
    },
    {
      code: 'fiu',
      value: {
        ja: 'フィン・ウゴル語派(その他)',
        en: 'Finno-Ugrian languages'
      }
    },
    {
      code: 'fon',
      value: {
        ja: 'フォン語',
        en: 'Fon'
      }
    },
    {
      code: 'fre',
      value: {
        ja: 'フランス語',
        en: 'French'
      }
    },
    {
      code: 'fra',
      value: {
        ja: 'フランス語',
        en: ''
      }
    },
    {
      code: 'frm',
      value: {
        ja: '中期フランス語',
        en: 'French, Middle (ca.1400-1600)'
      }
    },
    {
      code: 'fro',
      value: {
        ja: '古フランス語',
        en: 'French, Old (842-ca.1400)'
      }
    },
    {
      code: 'frr',
      value: {
        ja: '北フリジア語',
        en: 'Northern Frisian'
      }
    },
    {
      code: 'frs',
      value: {
        ja: '東フリジア語',
        en: 'Eastern Frisian'
      }
    },
    {
      code: 'fry',
      value: {
        ja: 'フリジア語/西フリジア語',
        en: 'Western Frisian'
      }
    },
    {
      code: 'ful',
      value: {
        ja: 'フラニ語/フルフルデ語',
        en: 'Fulah'
      }
    },
    {
      code: 'fur',
      value: {
        ja: 'フリウリ語',
        en: 'Friulian'
      }
    },
    {
      code: 'gaa',
      value: {
        ja: 'ガー語',
        en: 'Ga'
      }
    },
    {
      code: 'gay',
      value: {
        ja: 'ガヨ語',
        en: 'Gayo'
      }
    },
    {
      code: 'gba',
      value: {
        ja: 'グバヤ方言群',
        en: 'Gbaya'
      }
    },
    {
      code: 'gem',
      value: {
        ja: 'ゲルマン語派(その他)',
        en: 'Germanic languages'
      }
    },
    {
      code: 'geo',
      value: {
        ja: 'グルジア語',
        en: 'Georgian'
      }
    },
    {
      code: 'kat',
      value: {
        ja: 'グルジア語',
        en: ''
      }
    },
    {
      code: 'ger',
      value: {
        ja: 'ドイツ語',
        en: 'German'
      }
    },
    {
      code: 'deu',
      value: {
        ja: 'ドイツ語',
        en: ''
      }
    },
    {
      code: 'gez',
      value: {
        ja: 'ゲエズ語',
        en: 'Geez'
      }
    },
    {
      code: 'gil',
      value: {
        ja: 'キリバス語/ギルバート語',
        en: 'Gilbertese'
      }
    },
    {
      code: 'gla',
      value: {
        ja: '高地スコットランド・ゲール語',
        en: 'Gaelic; Scottish Gaelic'
      }
    },
    {
      code: 'gle',
      value: {
        ja: 'アイルランド語',
        en: 'Irish'
      }
    },
    {
      code: 'glg',
      value: {
        ja: 'ガリシア語',
        en: 'Galician'
      }
    },
    {
      code: 'glv',
      value: {
        ja: 'マン島語',
        en: 'Manx'
      }
    },
    {
      code: 'gmh',
      value: {
        ja: '中高ドイツ語',
        en: 'German, Middle High (ca.1050-1500)'
      }
    },
    {
      code: 'goh',
      value: {
        ja: '古高ドイツ語',
        en: 'German, Old High (ca.750-1050)'
      }
    },
    {
      code: 'gon',
      value: {
        ja: 'ゴーンディー語',
        en: 'Gondi'
      }
    },
    {
      code: 'gor',
      value: {
        ja: 'ゴロンタロ語',
        en: 'Gorontalo'
      }
    },
    {
      code: 'got',
      value: {
        ja: 'ゴート語',
        en: 'Gothic'
      }
    },
    {
      code: 'grb',
      value: {
        ja: 'グレボ小語群',
        en: 'Grebo'
      }
    },
    {
      code: 'grc',
      value: {
        ja: '古代ギリシア語',
        en: 'Greek, Ancient (to 1453)'
      }
    },
    {
      code: 'gre',
      value: {
        ja: '現代ギリシア語',
        en: 'Greek, Modern (1453-)'
      }
    },
    {
      code: 'ell',
      value: {
        ja: '現代ギリシア語',
        en: ''
      }
    },
    {
      code: 'grn',
      value: {
        ja: 'グァラニ語/ワラニー語',
        en: 'Guarani'
      }
    },
    {
      code: 'gsw',
      value: {
        ja: 'スイス・ドイツ語/アレマン語',
        en: 'Swiss German; Alemannic; Alsatian'
      }
    },
    {
      code: 'guj',
      value: {
        ja: 'グジャラート語',
        en: 'Gujarati'
      }
    },
    {
      code: 'gwi',
      value: {
        ja: 'クチン語',
        en: 'Gwich\'in'
      }
    },
    {
      code: 'hai',
      value: {
        ja: 'ハイダ語',
        en: 'Haida'
      }
    },
    {
      code: 'hat',
      value: {
        ja: 'ハイチ語/ハイチ・クレオール語',
        en: 'Haitian; Haitian Creole'
      }
    },
    {
      code: 'hau',
      value: {
        ja: 'ハウサ語',
        en: 'Hausa'
      }
    },
    {
      code: 'haw',
      value: {
        ja: 'ハワイ語',
        en: 'Hawaiian'
      }
    },
    {
      code: 'heb',
      value: {
        ja: 'ヘブライ語',
        en: 'Hebrew'
      }
    },
    {
      code: 'her',
      value: {
        ja: 'ヘレロ語',
        en: 'Herero'
      }
    },
    {
      code: 'hil',
      value: {
        ja: 'ヒリガイノン語',
        en: 'Hiligaynon'
      }
    },
    {
      code: 'him',
      value: {
        ja: 'ヒマチャリー語',
        en: 'Himachali languages; Western Pahari languages'
      }
    },
    {
      code: 'hin',
      value: {
        ja: 'ヒンディー語',
        en: 'Hindi'
      }
    },
    {
      code: 'hit',
      value: {
        ja: 'ヒッタイト語',
        en: 'Hittite'
      }
    },
    {
      code: 'hmn',
      value: {
        ja: 'フモン語',
        en: 'Hmong; Mong'
      }
    },
    {
      code: 'hmo',
      value: {
        ja: 'ヒリモトゥ語',
        en: 'Hiri Motu'
      }
    },
    {
      code: 'hsb',
      value: {
        ja: '上ソルブ語',
        en: 'Upper Sorbian'
      }
    },
    {
      code: 'hun',
      value: {
        ja: 'ハンガリー語/マジャル語',
        en: 'Hungarian'
      }
    },
    {
      code: 'hup',
      value: {
        ja: 'フーパ語',
        en: 'Hupa'
      }
    },
    {
      code: 'iba',
      value: {
        ja: 'イバン語',
        en: 'Iban'
      }
    },
    {
      code: 'ibo',
      value: {
        ja: 'イグボ語/イボ語',
        en: 'Igbo'
      }
    },
    {
      code: 'ice',
      value: {
        ja: 'アイスランド語',
        en: 'Icelandic'
      }
    },
    {
      code: 'isl',
      value: {
        ja: 'アイスランド語',
        en: ''
      }
    },
    {
      code: 'ido',
      value: {
        ja: 'イド語',
        en: 'Ido'
      }
    },
    {
      code: 'iii',
      value: {
        ja: '彝語',
        en: 'Sichuan Yi; Nuosu'
      }
    },
    {
      code: 'ijo',
      value: {
        ja: 'イジョー方言群',
        en: 'Ijo languages'
      }
    },
    {
      code: 'iku',
      value: {
        ja: 'イヌイット語/エスキモー語',
        en: 'Inuktitut'
      }
    },
    {
      code: 'ile',
      value: {
        ja: 'インターリング',
        en: 'Interlingue; Occidental'
      }
    },
    {
      code: 'ilo',
      value: {
        ja: 'イロカノ語',
        en: 'Iloko'
      }
    },
    {
      code: 'ina',
      value: {
        ja: 'インターリンガ語',
        en: 'Interlingua (International Auxiliary Language Association)'
      }
    },
    {
      code: 'inc',
      value: {
        ja: 'インド語派(その他)',
        en: 'Indic languages'
      }
    },
    {
      code: 'ind',
      value: {
        ja: 'インドネシア語',
        en: 'Indonesian'
      }
    },
    {
      code: 'ine',
      value: {
        ja: 'インド・ヨーロッパ語族(その他)',
        en: 'Indo-European languages'
      }
    },
    {
      code: 'inh',
      value: {
        ja: 'イングシ語',
        en: 'Ingush'
      }
    },
    {
      code: 'ipk',
      value: {
        ja: 'イヌピアック語',
        en: 'Inupiaq'
      }
    },
    {
      code: 'ira',
      value: {
        ja: 'イラン語派(その他)',
        en: 'Iranian languages'
      }
    },
    {
      code: 'iro',
      value: {
        ja: 'イロコイ語族',
        en: 'Iroquoian languages'
      }
    },
    {
      code: 'ita',
      value: {
        ja: 'イタリア語',
        en: 'Italian'
      }
    },
    {
      code: 'jav',
      value: {
        ja: 'ジャワ語',
        en: 'Javanese'
      }
    },
    {
      code: 'jaw',
      value: {
        ja: 'ジャワ語',
        en: ''
      }
    },
    {
      code: 'jbo',
      value: {
        ja: 'ロジバン語',
        en: 'Lojban'
      }
    },
    {
      code: 'jpn',
      value: {
        ja: '日本語',
        en: 'Japanese'
      }
    },
    {
      code: 'jpr',
      value: {
        ja: 'ユダヤ・ペルシア語',
        en: 'Judeo-Persian'
      }
    },
    {
      code: 'jrb',
      value: {
        ja: 'ユダヤ・アラビア語',
        en: 'Judeo-Arabic'
      }
    },
    {
      code: 'kaa',
      value: {
        ja: 'カラカルパク語',
        en: 'Kara-Kalpak'
      }
    },
    {
      code: 'kab',
      value: {
        ja: 'カビール語',
        en: 'Kabyle'
      }
    },
    {
      code: 'kac',
      value: {
        ja: 'カチン語',
        en: 'Kachin; Jingpho'
      }
    },
    {
      code: 'kal',
      value: {
        ja: 'グリーンランド語',
        en: 'Kalaallisut; Greenlandic'
      }
    },
    {
      code: 'kam',
      value: {
        ja: 'カンバ語',
        en: 'Kamba'
      }
    },
    {
      code: 'kan',
      value: {
        ja: 'カンナダ語',
        en: 'Kannada'
      }
    },
    {
      code: 'kar',
      value: {
        ja: 'カレン語群',
        en: 'Karen languages'
      }
    },
    {
      code: 'kas',
      value: {
        ja: 'カシュミール語',
        en: 'Kashmiri'
      }
    },
    {
      code: 'kau',
      value: {
        ja: 'カヌリ語',
        en: 'Kanuri'
      }
    },
    {
      code: 'kaw',
      value: {
        ja: 'カウィ語',
        en: 'Kawi'
      }
    },
    {
      code: 'kaz',
      value: {
        ja: 'カザフ語',
        en: 'Kazakh'
      }
    },
    {
      code: 'kbd',
      value: {
        ja: 'カバルド語',
        en: 'Kabardian'
      }
    },
    {
      code: 'kha',
      value: {
        ja: 'カシ語',
        en: 'Khasi'
      }
    },
    {
      code: 'khi',
      value: {
        ja: 'コイサン語族(その他)',
        en: 'Khoisan languages'
      }
    },
    {
      code: 'khm',
      value: {
        ja: 'カンボジア語/クメール語',
        en: 'Central Khmer'
      }
    },
    {
      code: 'kho',
      value: {
        ja: 'コータン語',
        en: 'Khotanese; Sakan'
      }
    },
    {
      code: 'kik',
      value: {
        ja: 'キクユ語',
        en: 'Kikuyu; Gikuyu'
      }
    },
    {
      code: 'kin',
      value: {
        ja: 'ルワンダ語',
        en: 'Kinyarwanda'
      }
    },
    {
      code: 'kir',
      value: {
        ja: 'キルギス語',
        en: 'Kirghiz; Kyrgyz'
      }
    },
    {
      code: 'kmb',
      value: {
        ja: 'キンブンドゥ語',
        en: 'Kimbundu'
      }
    },
    {
      code: 'kok',
      value: {
        ja: 'コーンカニー語',
        en: 'Konkani'
      }
    },
    {
      code: 'kom',
      value: {
        ja: 'コミ語',
        en: 'Komi'
      }
    },
    {
      code: 'kon',
      value: {
        ja: 'コンゴ語',
        en: 'Kongo'
      }
    },
    {
      code: 'kor',
      value: {
        ja: '韓国語/朝鮮語',
        en: 'Korean'
      }
    },
    {
      code: 'kos',
      value: {
        ja: 'コシャエ語',
        en: 'Kosraean'
      }
    },
    {
      code: 'kpe',
      value: {
        ja: 'クペレ語',
        en: 'Kpelle'
      }
    },
    {
      code: 'krc',
      value: {
        ja: 'カラチャイ・バルカル語',
        en: 'Karachay-Balkar'
      }
    },
    {
      code: 'krl',
      value: {
        ja: 'カレリア語',
        en: 'Karelian'
      }
    },
    {
      code: 'kro',
      value: {
        ja: 'クルー諸語',
        en: 'Kru languages'
      }
    },
    {
      code: 'kru',
      value: {
        ja: 'クルク語',
        en: 'Kurukh'
      }
    },
    {
      code: 'kua',
      value: {
        ja: 'クワニャマ語',
        en: 'Kuanyama; Kwanyama'
      }
    },
    {
      code: 'kum',
      value: {
        ja: 'クムク語',
        en: 'Kumyk'
      }
    },
    {
      code: 'kur',
      value: {
        ja: 'クルド語',
        en: 'Kurdish'
      }
    },
    {
      code: 'kut',
      value: {
        ja: 'クーテナイ語',
        en: 'Kutenai'
      }
    },
    {
      code: 'lad',
      value: {
        ja: 'ユダヤ・スペイン語',
        en: 'Ladino'
      }
    },
    {
      code: 'lah',
      value: {
        ja: 'ラーンダー語',
        en: 'Lahnda'
      }
    },
    {
      code: 'lam',
      value: {
        ja: 'ランバ語',
        en: 'Lamba'
      }
    },
    {
      code: 'lao',
      value: {
        ja: 'ラオ語',
        en: 'Lao'
      }
    },
    {
      code: 'lat',
      value: {
        ja: 'ラテン語',
        en: 'Latin'
      }
    },
    {
      code: 'lav',
      value: {
        ja: 'ラトビア語',
        en: 'Latvian'
      }
    },
    {
      code: 'lez',
      value: {
        ja: 'レズギ語',
        en: 'Lezghian'
      }
    },
    {
      code: 'lim',
      value: {
        ja: 'リンブルガー語',
        en: 'Limburgan; Limburger; Limburgish'
      }
    },
    {
      code: 'lin',
      value: {
        ja: 'リンガラ語',
        en: 'Lingala'
      }
    },
    {
      code: 'lit',
      value: {
        ja: 'リトアニア語',
        en: 'Lithuanian'
      }
    },
    {
      code: 'lol',
      value: {
        ja: 'モンゴ語',
        en: 'Mongo'
      }
    },
    {
      code: 'loz',
      value: {
        ja: 'ロズィ語',
        en: 'Lozi'
      }
    },
    {
      code: 'ltz',
      value: {
        ja: 'ルクセンブルク語',
        en: 'Luxembourgish; Letzeburgesch'
      }
    },
    {
      code: 'lua',
      value: {
        ja: 'ルバ・ルルア小語群',
        en: 'Luba-Lulua'
      }
    },
    {
      code: 'lub',
      value: {
        ja: 'キルバ語',
        en: 'Luba-Katanga'
      }
    },
    {
      code: 'lug',
      value: {
        ja: 'ガンダ語',
        en: 'Ganda'
      }
    },
    {
      code: 'lui',
      value: {
        ja: 'ルイセーニョ語',
        en: 'Luiseno'
      }
    },
    {
      code: 'lun',
      value: {
        ja: 'ルンダ語',
        en: 'Lunda'
      }
    },
    {
      code: 'luo',
      value: {
        ja: 'ルオ語',
        en: 'Luo (Kenya and Tanzania)'
      }
    },
    {
      code: 'lus',
      value: {
        ja: 'ルシャイ語',
        en: 'Lushai'
      }
    },
    {
      code: 'mac',
      value: {
        ja: 'マケドニア語',
        en: 'Macedonian'
      }
    },
    {
      code: 'mkd',
      value: {
        ja: 'マケドニア語',
        en: ''
      }
    },
    {
      code: 'mad',
      value: {
        ja: 'マドゥラ語',
        en: 'Madurese'
      }
    },
    {
      code: 'mag',
      value: {
        ja: 'マガヒー語',
        en: 'Magahi'
      }
    },
    {
      code: 'mah',
      value: {
        ja: 'マーシャル語',
        en: 'Marshallese'
      }
    },
    {
      code: 'mai',
      value: {
        ja: 'マイティリー語',
        en: 'Maithili'
      }
    },
    {
      code: 'mak',
      value: {
        ja: 'マカッサル語',
        en: 'Makasar'
      }
    },
    {
      code: 'mal',
      value: {
        ja: 'マラヤーラム語',
        en: 'Malayalam'
      }
    },
    {
      code: 'man',
      value: {
        ja: 'マンデ語/マンディンゴ語',
        en: 'Mandingo'
      }
    },
    {
      code: 'mao',
      value: {
        ja: 'マオリ語',
        en: 'Maori'
      }
    },
    {
      code: 'mri',
      value: {
        ja: 'マオリ語',
        en: ''
      }
    },
    {
      code: 'map',
      value: {
        ja: 'オーストロネシア語族(その他)',
        en: 'Austronesian languages'
      }
    },
    {
      code: 'mar',
      value: {
        ja: 'マラーティー語',
        en: 'Marathi'
      }
    },
    {
      code: 'mas',
      value: {
        ja: 'マサイ語',
        en: 'Masai'
      }
    },
    {
      code: 'may',
      value: {
        ja: 'マレー語',
        en: 'Malay'
      }
    },
    {
      code: 'msa',
      value: {
        ja: 'マレー語',
        en: ''
      }
    },
    {
      code: 'mdf',
      value: {
        ja: 'モクシャ語',
        en: 'Moksha'
      }
    },
    {
      code: 'mdr',
      value: {
        ja: 'マンダル語',
        en: 'Mandar'
      }
    },
    {
      code: 'men',
      value: {
        ja: 'メンデ語',
        en: 'Mende'
      }
    },
    {
      code: 'mga',
      value: {
        ja: '中期アイルランド語',
        en: 'Irish, Middle (900-1200)'
      }
    },
    {
      code: 'mic',
      value: {
        ja: 'ミクマック語',
        en: 'Mi\'kmaq; Micmac'
      }
    },
    {
      code: 'min',
      value: {
        ja: 'ミナンカバウ語',
        en: 'Minangkabau'
      }
    },
    {
      code: 'mis',
      value: {
        ja: 'その他の言語',
        en: 'Uncoded languages'
      }
    },
    {
      code: 'mkh',
      value: {
        ja: 'モン・クメール語派(その他)',
        en: 'Mon-Khmer languages'
      }
    },
    {
      code: 'mlg',
      value: {
        ja: 'マラガシ語',
        en: 'Malagasy'
      }
    },
    {
      code: 'mlt',
      value: {
        ja: 'マルタ語',
        en: 'Maltese'
      }
    },
    {
      code: 'mnc',
      value: {
        ja: '満州語',
        en: 'Manchu'
      }
    },
    {
      code: 'mni',
      value: {
        ja: 'マニプル語',
        en: 'Manipuri'
      }
    },
    {
      code: 'mno',
      value: {
        ja: 'マノボ語族',
        en: 'Manobo languages'
      }
    },
    {
      code: 'moh',
      value: {
        ja: 'モホーク語',
        en: 'Mohawk'
      }
    },
    {
      code: 'mol',
      value: {
        ja: 'モルダビア語',
        en: ''
      }
    },
    {
      code: 'mon',
      value: {
        ja: '満州語/モンゴル語',
        en: 'Mongolian'
      }
    },
    {
      code: 'mos',
      value: {
        ja: 'モシ語',
        en: 'Mossi'
      }
    },
    {
      code: 'mul',
      value: {
        ja: '複数言語',
        en: 'Multiple languages'
      }
    },
    {
      code: 'mun',
      value: {
        ja: 'ムンダー諸語',
        en: 'Munda languages'
      }
    },
    {
      code: 'mus',
      value: {
        ja: 'クリーク語',
        en: 'Creek'
      }
    },
    {
      code: 'mwl',
      value: {
        ja: 'ミランダ語',
        en: 'Mirandese'
      }
    },
    {
      code: 'mwr',
      value: {
        ja: 'マールワーリー語',
        en: 'Marwari'
      }
    },
    {
      code: 'myn',
      value: {
        ja: 'マヤ語族',
        en: 'Mayan languages'
      }
    },
    {
      code: 'myv',
      value: {
        ja: 'エルジャ語',
        en: 'Erzya'
      }
    },
    {
      code: 'nah',
      value: {
        ja: 'ナワトル語',
        en: 'Nahuatl languages'
      }
    },
    {
      code: 'nai',
      value: {
        ja: '北米インディアン諸語(その他)',
        en: 'North American Indian languages'
      }
    },
    {
      code: 'nap',
      value: {
        ja: 'ナポリ語',
        en: 'Neapolitan'
      }
    },
    {
      code: 'nau',
      value: {
        ja: 'ナウル語',
        en: 'Nauru'
      }
    },
    {
      code: 'nav',
      value: {
        ja: 'ナバホ語',
        en: 'Navajo; Navaho'
      }
    },
    {
      code: 'nbl',
      value: {
        ja: '南ンデベレ語',
        en: 'Ndebele, South; South Ndebele'
      }
    },
    {
      code: 'nde',
      value: {
        ja: '北ンデベレ語',
        en: 'Ndebele, North; North Ndebele'
      }
    },
    {
      code: 'ndo',
      value: {
        ja: 'ンドゥンガ語',
        en: 'Ndonga'
      }
    },
    {
      code: 'nds',
      value: {
        ja: '低地ドイツ語',
        en: 'Low German; Low Saxon; German, Low; Saxon, Low'
      }
    },
    {
      code: 'nep',
      value: {
        ja: 'ネパール語',
        en: 'Nepali'
      }
    },
    {
      code: 'new',
      value: {
        ja: 'ネワール語',
        en: 'Nepal Bhasa; Newari'
      }
    },
    {
      code: 'nia',
      value: {
        ja: 'ニアス語',
        en: 'Nias'
      }
    },
    {
      code: 'nic',
      value: {
        ja: 'ニジェール・コルドファン語族(その他)',
        en: 'Niger-Kordofanian languages'
      }
    },
    {
      code: 'niu',
      value: {
        ja: 'ニウエー語',
        en: 'Niuean'
      }
    },
    {
      code: 'nno',
      value: {
        ja: 'ニューノシュク',
        en: 'Norwegian Nynorsk; Nynorsk, Norwegian'
      }
    },
    {
      code: 'nob',
      value: {
        ja: 'ブークモール',
        en: 'Bokmål, Norwegian; Norwegian Bokmål'
      }
    },
    {
      code: 'nog',
      value: {
        ja: 'ノガイ語',
        en: 'Nogai'
      }
    },
    {
      code: 'non',
      value: {
        ja: '古ノルド語',
        en: 'Norse, Old'
      }
    },
    {
      code: 'nor',
      value: {
        ja: 'ノルウェー語',
        en: 'Norwegian'
      }
    },
    {
      code: 'nqo',
      value: {
        ja: 'ンコ語',
        en: 'N\'Ko'
      }
    },
    {
      code: 'nso',
      value: {
        ja: '北ソト語',
        en: 'Pedi; Sepedi; Northern Sotho'
      }
    },
    {
      code: 'nub',
      value: {
        ja: 'ヌビア語群',
        en: 'Nubian languages'
      }
    },
    {
      code: 'nwc',
      value: {
        ja: '古典ネワール語',
        en: 'Classical Newari; Old Newari; Classical Nepal Bhasa'
      }
    },
    {
      code: 'nya',
      value: {
        ja: 'チェワ語/ニャンジャ語',
        en: 'Chichewa; Chewa; Nyanja'
      }
    },
    {
      code: 'nym',
      value: {
        ja: 'ニャムウェズィ語',
        en: 'Nyamwezi'
      }
    },
    {
      code: 'nyn',
      value: {
        ja: 'ニャンコレ語',
        en: 'Nyankole'
      }
    },
    {
      code: 'nyo',
      value: {
        ja: 'ニョロ語',
        en: 'Nyoro'
      }
    },
    {
      code: 'nzi',
      value: {
        ja: 'ンジマ語',
        en: 'Nzima'
      }
    },
    {
      code: 'oci',
      value: {
        ja: 'オック語',
        en: 'Occitan (post 1500); Provençal'
      }
    },
    {
      code: 'oji',
      value: {
        ja: 'オジブワ語',
        en: 'Ojibwa'
      }
    },
    {
      code: 'ori',
      value: {
        ja: 'オリヤー語',
        en: 'Oriya'
      }
    },
    {
      code: 'orm',
      value: {
        ja: 'オロモ語/ガッラ語',
        en: 'Oromo'
      }
    },
    {
      code: 'osa',
      value: {
        ja: 'オセージ語',
        en: 'Osage'
      }
    },
    {
      code: 'oss',
      value: {
        ja: 'オセット語',
        en: 'Ossetian; Ossetic'
      }
    },
    {
      code: 'ota',
      value: {
        ja: 'オスマン・トルコ語',
        en: 'Turkish, Ottoman (1500-1928)'
      }
    },
    {
      code: 'oto',
      value: {
        ja: 'オトミ語',
        en: 'Otomian languages'
      }
    },
    {
      code: 'paa',
      value: {
        ja: 'パプア諸語(その他)',
        en: 'Papuan languages'
      }
    },
    {
      code: 'pag',
      value: {
        ja: 'パンガシナン語',
        en: 'Pangasinan'
      }
    },
    {
      code: 'pal',
      value: {
        ja: '中期ペルシア語/パフラビ語',
        en: 'Pahlavi'
      }
    },
    {
      code: 'pam',
      value: {
        ja: 'カパンパンガン語',
        en: 'Pampanga; Kapampangan'
      }
    },
    {
      code: 'pan',
      value: {
        ja: 'パンジャーブ語',
        en: 'Panjabi; Punjabi'
      }
    },
    {
      code: 'pap',
      value: {
        ja: 'パピアメント語',
        en: 'Papiamento'
      }
    },
    {
      code: 'pau',
      value: {
        ja: 'パラオ語',
        en: 'Palauan'
      }
    },
    {
      code: 'peo',
      value: {
        ja: '古代ペルシア語',
        en: 'Persian, Old (ca.600-400 B.C.)'
      }
    },
    {
      code: 'per',
      value: {
        ja: 'ペルシア語',
        en: 'Persian'
      }
    },
    {
      code: 'fas',
      value: {
        ja: 'ペルシア語',
        en: ''
      }
    },
    {
      code: 'phi',
      value: {
        ja: 'フィリピン諸語(その他)',
        en: 'Philippine languages'
      }
    },
    {
      code: 'phn',
      value: {
        ja: 'フェニキア語',
        en: 'Phoenician'
      }
    },
    {
      code: 'pli',
      value: {
        ja: 'パーリ語',
        en: 'Pali'
      }
    },
    {
      code: 'pol',
      value: {
        ja: 'ポーランド語',
        en: 'Polish'
      }
    },
    {
      code: 'pon',
      value: {
        ja: 'ポナペ語',
        en: 'Pohnpeian'
      }
    },
    {
      code: 'por',
      value: {
        ja: 'ポルトガル語',
        en: 'Portuguese'
      }
    },
    {
      code: 'pra',
      value: {
        ja: 'プラークリット語',
        en: 'Prakrit languages'
      }
    },
    {
      code: 'pro',
      value: {
        ja: 'プロバンス語',
        en: 'Provençal, Old (to 1500)'
      }
    },
    {
      code: 'pus',
      value: {
        ja: 'パシュトー語',
        en: 'Pushto; Pashto'
      }
    },
    {
      code: 'qaa-qtz',
      value: {
        ja: '局地用',
        en: ''
      }
    },
    {
      code: 'qaa',
      value: {
        ja: '局地用',
        en: ''
      }
    },
    {
      code: 'que',
      value: {
        ja: 'ケチュア語',
        en: 'Quechua'
      }
    },
    {
      code: 'raj',
      value: {
        ja: 'ラージャスターン語',
        en: 'Rajasthani'
      }
    },
    {
      code: 'rap',
      value: {
        ja: 'ラパヌイ語',
        en: 'Rapanui'
      }
    },
    {
      code: 'rar',
      value: {
        ja: 'ラロトンガ語',
        en: 'Rarotongan; Cook Islands Maori'
      }
    },
    {
      code: 'roa',
      value: {
        ja: 'ロマンス諸語(その他)',
        en: 'Romance languages'
      }
    },
    {
      code: 'roh',
      value: {
        ja: 'レト・ロマンス語/ロマンシュ語',
        en: 'Romansh'
      }
    },
    {
      code: 'rom',
      value: {
        ja: 'ロマーニー語',
        en: 'Romany'
      }
    },
    {
      code: 'rum',
      value: {
        ja: 'ルーマニア語',
        en: 'Romanian; Moldavian; Moldovan'
      }
    },
    {
      code: 'ron',
      value: {
        ja: 'ルーマニア語',
        en: ''
      }
    },
    {
      code: 'run',
      value: {
        ja: 'ルンディ語',
        en: 'Rundi'
      }
    },
    {
      code: 'rup',
      value: {
        ja: 'アルーマニア語/マケド・ルーマニア語',
        en: 'Aromanian; Arumanian; Macedo-Romanian'
      }
    },
    {
      code: 'rus',
      value: {
        ja: 'ロシア語',
        en: 'Russian'
      }
    },
    {
      code: 'sad',
      value: {
        ja: 'サンダウェ語',
        en: 'Sandawe'
      }
    },
    {
      code: 'sag',
      value: {
        ja: 'サンゴ語',
        en: 'Sango'
      }
    },
    {
      code: 'sah',
      value: {
        ja: 'ヤクート語',
        en: 'Yakut'
      }
    },
    {
      code: 'sai',
      value: {
        ja: '南米インディアン諸語(その他)',
        en: 'South American Indian (Other)'
      }
    },
    {
      code: 'sal',
      value: {
        ja: 'セイリッシュ語族',
        en: 'Salishan languages'
      }
    },
    {
      code: 'sam',
      value: {
        ja: 'サマリア・アラム語',
        en: 'Samaritan Aramaic'
      }
    },
    {
      code: 'san',
      value: {
        ja: 'サンスクリット語',
        en: 'Sanskrit'
      }
    },
    {
      code: 'sas',
      value: {
        ja: 'ササク語',
        en: 'Sasak'
      }
    },
    {
      code: 'sat',
      value: {
        ja: 'サンタール語',
        en: 'Santali'
      }
    },
    {
      code: 'scc',
      value: {
        ja: 'セルビア語',
        en: ''
      }
    },
    {
      code: 'srp',
      value: {
        ja: 'セルビア語',
        en: 'Serbian'
      }
    },
    {
      code: 'scn',
      value: {
        ja: 'シチリア語',
        en: 'Sicilian'
      }
    },
    {
      code: 'sco',
      value: {
        ja: '低地スコットランド・ゲール語',
        en: 'Scots'
      }
    },
    {
      code: 'scr',
      value: {
        ja: 'クロアチア語',
        en: ''
      }
    },
    {
      code: 'hrv',
      value: {
        ja: 'クロアチア語',
        en: 'Croatian'
      }
    },
    {
      code: 'sel',
      value: {
        ja: 'セリクプ語',
        en: 'Selkup'
      }
    },
    {
      code: 'sem',
      value: {
        ja: 'セム語族(その他)',
        en: 'Semitic languages'
      }
    },
    {
      code: 'sga',
      value: {
        ja: '古アイルランド語',
        en: 'Irish, Old (to 900)'
      }
    },
    {
      code: 'sgn',
      value: {
        ja: '手話',
        en: 'Sign Languages'
      }
    },
    {
      code: 'shn',
      value: {
        ja: 'シャン語',
        en: 'Shan'
      }
    },
    {
      code: 'sid',
      value: {
        ja: 'シダモ語',
        en: 'Sidamo'
      }
    },
    {
      code: 'sin',
      value: {
        ja: 'シンハラ語',
        en: 'Sinhala; Sinhalese'
      }
    },
    {
      code: 'sio',
      value: {
        ja: 'スー語族',
        en: 'Siouan languages'
      }
    },
    {
      code: 'sit',
      value: {
        ja: 'シナ・チベット語族(その他)',
        en: 'Sino-Tibetan languages'
      }
    },
    {
      code: 'sla',
      value: {
        ja: 'スラブ語派(その他)',
        en: 'Slavic languages'
      }
    },
    {
      code: 'slo',
      value: {
        ja: 'スロバキア語',
        en: 'Slovak'
      }
    },
    {
      code: 'slk',
      value: {
        ja: 'スロバキア語',
        en: ''
      }
    },
    {
      code: 'slv',
      value: {
        ja: 'スロベニア語',
        en: 'Slovenian'
      }
    },
    {
      code: 'sma',
      value: {
        ja: '南サーミ語',
        en: 'Southern Sami'
      }
    },
    {
      code: 'sme',
      value: {
        ja: '北サーミ語',
        en: 'Northern Sami'
      }
    },
    {
      code: 'smi',
      value: {
        ja: 'サーミ語(その他)',
        en: 'Sami languages'
      }
    },
    {
      code: 'smj',
      value: {
        ja: 'ルレ・サーミ語',
        en: 'Lule Sami'
      }
    },
    {
      code: 'smn',
      value: {
        ja: 'イナリ・サーミ語',
        en: 'Inari Sami'
      }
    },
    {
      code: 'smo',
      value: {
        ja: 'サモア語',
        en: 'Samoan'
      }
    },
    {
      code: 'sms',
      value: {
        ja: 'スコルト・サーミ語',
        en: 'Skolt Sami'
      }
    },
    {
      code: 'sna',
      value: {
        ja: 'ショナ語',
        en: 'Shona'
      }
    },
    {
      code: 'snd',
      value: {
        ja: 'シンド語',
        en: 'Sindhi'
      }
    },
    {
      code: 'snk',
      value: {
        ja: 'ソニンケ語',
        en: 'Soninke'
      }
    },
    {
      code: 'sog',
      value: {
        ja: 'ソグド語',
        en: 'Sogdian'
      }
    },
    {
      code: 'som',
      value: {
        ja: 'ソマリ語',
        en: 'Somali'
      }
    },
    {
      code: 'son',
      value: {
        ja: 'ソンガイ語',
        en: 'Songhai languages'
      }
    },
    {
      code: 'sot',
      value: {
        ja: '南ソト語',
        en: 'Sotho, Southern'
      }
    },
    {
      code: 'spa',
      value: {
        ja: 'スペイン語/カスティーヤ語',
        en: 'Spanish; Castilian'
      }
    },
    {
      code: 'srd',
      value: {
        ja: 'サルデーニャ語',
        en: 'Sardinian'
      }
    },
    {
      code: 'srn',
      value: {
        ja: 'スラナン語',
        en: 'Sranan Tongo'
      }
    },
    {
      code: 'srr',
      value: {
        ja: 'セレル語',
        en: 'Serer'
      }
    },
    {
      code: 'ssa',
      value: {
        ja: 'ナイル・サハラ言語群(その他)',
        en: 'Nilo-Saharan languages'
      }
    },
    {
      code: 'ssw',
      value: {
        ja: 'スワティ語',
        en: 'Swati'
      }
    },
    {
      code: 'suk',
      value: {
        ja: 'スクマ語',
        en: 'Sukuma'
      }
    },
    {
      code: 'sun',
      value: {
        ja: 'スンダ語',
        en: 'Sundanese'
      }
    },
    {
      code: 'sus',
      value: {
        ja: 'スス語',
        en: 'Susu'
      }
    },
    {
      code: 'sux',
      value: {
        ja: 'シュメール語',
        en: 'Sumerian'
      }
    },
    {
      code: 'swa',
      value: {
        ja: 'スワヒリ語',
        en: 'Swahili'
      }
    },
    {
      code: 'swe',
      value: {
        ja: 'スウェーデン語',
        en: 'Swedish'
      }
    },
    {
      code: 'syc',
      value: {
        ja: '古典シリア語',
        en: 'Classical Syriac'
      }
    },
    {
      code: 'syr',
      value: {
        ja: 'シリア語',
        en: 'Syriac'
      }
    },
    {
      code: 'tah',
      value: {
        ja: 'タヒチ語',
        en: 'Tahitian'
      }
    },
    {
      code: 'tai',
      value: {
        ja: 'タイ諸語(その他)',
        en: 'Tai languages'
      }
    },
    {
      code: 'tam',
      value: {
        ja: 'タミル語',
        en: 'Tamil'
      }
    },
    {
      code: 'tat',
      value: {
        ja: 'タタール語',
        en: 'Tatar'
      }
    },
    {
      code: 'tel',
      value: {
        ja: 'テルグ語',
        en: 'Telugu'
      }
    },
    {
      code: 'tem',
      value: {
        ja: 'テムネ語',
        en: 'Timne'
      }
    },
    {
      code: 'ter',
      value: {
        ja: 'テレーノ語',
        en: 'Tereno'
      }
    },
    {
      code: 'tet',
      value: {
        ja: 'テトゥン語',
        en: 'Tetum'
      }
    },
    {
      code: 'tgk',
      value: {
        ja: 'タジク語',
        en: 'Tajik'
      }
    },
    {
      code: 'tgl',
      value: {
        ja: 'タガログ語',
        en: 'Tagalog'
      }
    },
    {
      code: 'tha',
      value: {
        ja: 'タイ語',
        en: 'Thai'
      }
    },
    {
      code: 'tib',
      value: {
        ja: 'チベット語',
        en: 'Tibetan'
      }
    },
    {
      code: 'bod',
      value: {
        ja: 'チベット語',
        en: ''
      }
    },
    {
      code: 'tig',
      value: {
        ja: 'ティグレ語',
        en: 'Tigre'
      }
    },
    {
      code: 'tir',
      value: {
        ja: 'ティグリニア語',
        en: 'Tigrinya'
      }
    },
    {
      code: 'tiv',
      value: {
        ja: 'ティブ語',
        en: 'Tiv'
      }
    },
    {
      code: 'tkl',
      value: {
        ja: 'トケラウ語',
        en: 'Tokelau'
      }
    },
    {
      code: 'tlh',
      value: {
        ja: 'クリンゴン語',
        en: 'Klingon; tlhIngan-Hol'
      }
    },
    {
      code: 'tli',
      value: {
        ja: 'トリンギット語',
        en: 'Tlingit'
      }
    },
    {
      code: 'tmh',
      value: {
        ja: 'トゥアレグ語',
        en: 'Tamashek'
      }
    },
    {
      code: 'tog',
      value: {
        ja: 'トンガ語(ニヤサ地方)',
        en: 'Tonga (Nyasa)'
      }
    },
    {
      code: 'ton',
      value: {
        ja: 'トンガ語(トンガ諸島)',
        en: 'Tonga (Tonga Islands)'
      }
    },
    {
      code: 'tpi',
      value: {
        ja: 'トク・ピシン',
        en: 'Tok Pisin'
      }
    },
    {
      code: 'tsi',
      value: {
        ja: 'ツィムシアン語',
        en: 'Tsimshian'
      }
    },
    {
      code: 'tsn',
      value: {
        ja: 'ツワナ語',
        en: 'Tswana'
      }
    },
    {
      code: 'tso',
      value: {
        ja: 'ツォンガ語',
        en: 'Tsonga'
      }
    },
    {
      code: 'tuk',
      value: {
        ja: 'トルクメン語',
        en: 'Turkmen'
      }
    },
    {
      code: 'tum',
      value: {
        ja: 'トゥンブカ語',
        en: 'Tumbuka'
      }
    },
    {
      code: 'tup',
      value: {
        ja: 'トゥピ語族',
        en: 'Tupi languages'
      }
    },
    {
      code: 'tur',
      value: {
        ja: 'トルコ語',
        en: 'Turkish'
      }
    },
    {
      code: 'tut',
      value: {
        ja: 'アルタイ諸言語(その他)',
        en: 'Altaic languages'
      }
    },
    {
      code: 'tvl',
      value: {
        ja: 'ツバル語',
        en: 'Tuvalu'
      }
    },
    {
      code: 'twi',
      value: {
        ja: 'チュイ語',
        en: 'Twi'
      }
    },
    {
      code: 'tyv',
      value: {
        ja: 'トゥワ語',
        en: 'Tuvinian'
      }
    },
    {
      code: 'udm',
      value: {
        ja: 'ウドムルト語',
        en: 'Udmurt'
      }
    },
    {
      code: 'uga',
      value: {
        ja: 'ウガリト語',
        en: 'Ugaritic'
      }
    },
    {
      code: 'uig',
      value: {
        ja: 'ウイグル語',
        en: 'Uighur; Uyghur'
      }
    },
    {
      code: 'ukr',
      value: {
        ja: 'ウクライナ語',
        en: 'Ukrainian'
      }
    },
    {
      code: 'umb',
      value: {
        ja: 'ウンブンドゥ語',
        en: 'Umbundu'
      }
    },
    {
      code: 'und',
      value: {
        ja: '不明言語',
        en: 'Undetermined'
      }
    },
    {
      code: 'urd',
      value: {
        ja: 'ウルドゥー語',
        en: 'Urdu'
      }
    },
    {
      code: 'uzb',
      value: {
        ja: 'ウズベク語',
        en: 'Uzbek'
      }
    },
    {
      code: 'vai',
      value: {
        ja: 'バイ語',
        en: 'Vai'
      }
    },
    {
      code: 'ven',
      value: {
        ja: 'ベンダ語',
        en: 'Venda'
      }
    },
    {
      code: 'vie',
      value: {
        ja: 'ベトナム語',
        en: 'Vietnamese'
      }
    },
    {
      code: 'vol',
      value: {
        ja: 'ボラピューク語',
        en: 'Volapük'
      }
    },
    {
      code: 'vot',
      value: {
        ja: 'ボート語',
        en: 'Votic'
      }
    },
    {
      code: 'wak',
      value: {
        ja: 'ワカシュ語族',
        en: 'Wakashan languages'
      }
    },
    {
      code: 'wal',
      value: {
        ja: 'ワッラモ語',
        en: 'Walamo'
      }
    },
    {
      code: 'war',
      value: {
        ja: 'ワライ語',
        en: 'Waray'
      }
    },
    {
      code: 'was',
      value: {
        ja: 'ワショ語',
        en: 'Washo'
      }
    },
    {
      code: 'wel',
      value: {
        ja: 'ウェールズ語',
        en: 'Welsh'
      }
    },
    {
      code: 'cym',
      value: {
        ja: 'ウェールズ語',
        en: ''
      }
    },
    {
      code: 'wen',
      value: {
        ja: 'ソルブ語',
        en: 'Sorbian languages'
      }
    },
    {
      code: 'wln',
      value: {
        ja: 'ワロン語',
        en: 'Walloon'
      }
    },
    {
      code: 'wol',
      value: {
        ja: 'ウォロフ語',
        en: 'Wolof'
      }
    },
    {
      code: 'xal',
      value: {
        ja: 'カルムイク語/オイラト語',
        en: 'Kalmyk; Oirat'
      }
    },
    {
      code: 'xho',
      value: {
        ja: 'コサ語',
        en: 'Xhosa'
      }
    },
    {
      code: 'yao',
      value: {
        ja: 'ヤオ語',
        en: 'Yao'
      }
    },
    {
      code: 'yap',
      value: {
        ja: 'ヤップ語',
        en: 'Yapese'
      }
    },
    {
      code: 'yid',
      value: {
        ja: 'イディッシュ語',
        en: 'Yiddish'
      }
    },
    {
      code: 'yor',
      value: {
        ja: 'ヨルバ語',
        en: 'Yoruba'
      }
    },
    {
      code: 'ypk',
      value: {
        ja: 'ユピック語',
        en: 'Yupik languages'
      }
    },
    {
      code: 'zap',
      value: {
        ja: 'サポテック語',
        en: 'Zapotec'
      }
    },
    {
      code: 'zbl',
      value: {
        ja: 'サポテック語',
        en: 'Blissymbols; Blissymbolics; Bliss'
      }
    },
    {
      code: 'zen',
      value: {
        ja: 'ゼナガ語',
        en: 'Zenaga'
      }
    },
    {
      code: 'zha',
      value: {
        ja: 'チュワン語',
        en: 'Zhuang; Chuang'
      }
    },
    {
      code: 'znd',
      value: {
        ja: 'ザンデ語',
        en: 'Zande languages'
      }
    },
    {
      code: 'zul',
      value: {
        ja: 'ズールー語',
        en: 'Zulu'
      }
    },
    {
      code: 'zun',
      value: {
        ja: 'ズニ語',
        en: 'Zuni'
      }
    },
    {
      code: 'zxx',
      value: {
        ja: '言語的内容なし',
        en: 'No linguistic content; Not applicable'
      }
    },
    {
      code: 'zza',
      value: {
        ja: 'ザザキ語',
        en: 'Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki'
      }
    }
  ]
})
export const CODE_RDF_TYPE: Code = Object.freeze({
  id: 'jps-rdf_type',
  type: 'SYSTEM',
  values: [
    {
      code: '3d',
      value: {
        ja: '3D・モーションキャプチャ',
        en: '3D and motion capture'
      },
      equivalence: [
        '3D資料'
      ]
    },
    {
      code: 'website',
      value: {
        ja: 'ウェブサイト',
        en: 'Website'
      },
      equivalence: [
        'ウェブサイト'
      ]
    },
    {
      code: 'poster',
      value: {
        ja: 'ポスター・デザイン',
        en: 'Poster and design'
      },
      equivalence: [
        'デザイン',
        'ポスター',
        '端物印刷物'
      ]
    },
    {
      code: 'mediaart',
      value: {
        ja: 'メディア芸術',
        en: 'Mediar art'
      },
      equivalence: [
        'メディア芸術'
      ]
    },
    {
      code: 'performance',
      value: {
        ja: '上演・公演・演奏',
        en: 'Performance'
      },
      equivalence: [
        '上演',
        '演奏',
        'パフォーマンス',
        '公演'
      ]
    },
    {
      code: 'docs',
      value: {
        ja: 'その他',
        en: 'Others'
      },
      equivalence: [
        '文書資料',
        '資料一般',
        '出版物',
        '文章要素',
        '法人文書',
        '個人・団体の文書資料'
      ]
    },
    {
      code: 'offdoc',
      value: {
        ja: '公文書',
        en: 'Official document'
      },
      equivalence: [
        '会議録',
        '行政文書',
        '政府刊行物'
      ]
    },
    {
      code: 'photo',
      value: {
        ja: '写真',
        en: 'Photo'
      },
      equivalence: [
        '写真',
        '記録写真'
      ]
    },
    {
      code: 'weaponry',
      value: {
        ja: '刀剣・武器',
        en: 'Weaponry'
      },
      equivalence: [
        '刀剣',
        '武器',
        '金工・武器'
      ]
    },
    {
      code: 'poetry',
      value: {
        ja: '短歌・和歌・俳句・詩',
        en: 'Poetry'
      },
      equivalence: [
        '収録作品'
      ]
    },
    {
      code: 'ancdoc',
      value: {
        ja: '古文書',
        en: 'Ancient documents'
      },
      equivalence: [
        '古書・古文書',
        '書跡',
        '書簡',
        '書写資料',
        '稀覯書'
      ]
    },
    {
      code: 'site',
      value: {
        ja: '史跡・名勝・天然記念物',
        en: 'Sites'
      },
      equivalence: [
        '史跡',
        '名勝',
        '天然記念物'
      ]
    },
    {
      code: 'book',
      value: {
        ja: '図書',
        en: 'Book'
      },
      equivalence: [
        '図書',
        '画集・画本'
      ]
    },
    {
      code: 'article',
      value: {
        ja: '記事・論文',
        en: 'Articles'
      },
      equivalence: [
        '博士論文',
        '記事・論文',
        '記事'
      ]
    },
    {
      code: 'map',
      value: {
        ja: '地図',
        en: 'Map'
      },
      equivalence: [
        '地図資料'
      ]
    },
    {
      code: 'exhibition',
      value: {
        ja: '展覧会の日程や場所',
        en: 'Exhibition dates and locations'
      },
      equivalence: [
        '展覧会'
      ]
    },
    {
      code: 'architecture',
      value: {
        ja: '建築',
        en: 'Architecture'
      },
      equivalence: [
        '建造物・建築',
        '建築'
      ]
    },
    {
      code: 'broadcast',
      value: {
        ja: '放送番組',
        en: 'Broadcast program'
      },
      equivalence: [
        '放送番組'
      ]
    },
    {
      code: 'video',
      value: {
        ja: '映像',
        en: 'Video'
      },
      equivalence: [
        '映像資料'
      ]
    },
    {
      code: 'movie',
      value: {
        ja: '映画',
        en: 'Movie'
      },
      equivalence: [
        '映画'
      ]
    },
    {
      code: 'woodw',
      value: {
        ja: '木工',
        en: 'Woodworking'
      },
      equivalence: [
        '木工'
      ]
    },
    {
      code: 'daw',
      value: {
        ja: '染織',
        en: 'Dyeing and weaving'
      },
      equivalence: [
        '染織'
      ]
    },
    {
      code: 'mscore',
      value: {
        ja: '楽譜',
        en: 'Musical score'
      },
      equivalence: [
        '楽譜'
      ]
    },
    {
      code: 'lacquer',
      value: {
        ja: '漆工',
        en: 'Lacquering'
      },
      equivalence: [
        '漆工'
      ]
    },
    {
      code: 'stone',
      value: {
        ja: '石碑',
        en: 'Stone monument'
      },
      equivalence: [
        '石碑'
      ]
    },
    {
      code: 'craft',
      value: {
        ja: 'その他',
        en: 'Others'
      },
      equivalence: [
        '竹工芸',
        '工芸',
        '装飾・工芸',
        '屏風',
        '楽器',
        '面',
        '硬貨',
        '馬具'
      ]
    },
    {
      code: 'arts',
      value: {
        ja: 'その他',
        en: 'Others'
      },
      equivalence: [
        '芸術・美術',
        '建築・芸術',
        'インスタレーション'
      ]
    },
    {
      code: 'sculpture',
      value: {
        ja: '彫刻',
        en: 'Scuplture'
      },
      equivalence: [
        '彫刻'
      ]
    },
    {
      code: 'paint',
      value: {
        ja: '絵画・版画',
        en: 'Paintings and prints'
      },
      equivalence: [
        '絵画等',
        '絵画',
        '版画',
        '水彩',
        '素描'
      ]
    },
    {
      code: 'game',
      value: {
        ja: 'ゲーム',
        en: 'Game'
      },
      equivalence: [
        'ゲーム'
      ]
    },
    {
      code: 'anime',
      value: {
        ja: 'アニメーション',
        en: 'Animation'
      },
      equivalence: [
        'アニメーション'
      ]
    },
    {
      code: 'media',
      value: {
        ja: 'その他',
        en: 'Others'
      },
      equivalence: [
        '静止画資料'
      ]
    },
    {
      code: 'postcard',
      value: {
        ja: '絵葉書など',
        en: 'Postcard '
      },
      equivalence: [
        '絵葉書'
      ]
    },
    {
      code: 'archeology',
      value: {
        ja: '考古・民俗',
        en: 'Archeology and folklore'
      },
      equivalence: [
        '考古',
        '歴史資料',
        '民族資料',
        '拓本'
      ]
    },
    {
      code: 'natural',
      value: {
        ja: '博物',
        en: 'Natural history'
      },
      equivalence: [
        '博物資料',
        '標本',
        '植物標本'
      ]
    },
    {
      code: 'metal',
      value: {
        ja: '金工',
        en: 'Metalworking'
      },
      equivalence: [
        '金工'
      ]
    },
    {
      code: 'mineral',
      value: {
        ja: '鉱物',
        en: 'Mineral'
      },
      equivalence: [
        '宝石'
      ]
    },
    {
      code: 'recording',
      value: {
        ja: '録音',
        en: 'Recording'
      },
      equivalence: [
        '録音資料'
      ]
    },
    {
      code: 'ceramic',
      value: {
        ja: '陶磁',
        en: 'Ceramic'
      },
      equivalence: [
        '陶磁'
      ]
    },
    {
      code: 'periodical',
      value: {
        ja: '雑誌・新聞・定期刊行物',
        en: 'Magazines, newspapers, periodicals'
      },
      equivalence: [
        '雑誌・新聞・継続資料',
        '雑誌',
        '新聞'
      ]
    },
    {
      code: 'ematerial',
      value: {
        ja: '電子資料',
        en: 'Electronic materials'
      },
      equivalence: [
        '電子資料'
      ]
    },
    {
      code: 'customs',
      value: {
        ja: '風俗・祭事',
        en: 'Customs and festivals'
      },
      equivalence: [
        '風俗・祭事'
      ]
    },
    {
      code: 'org',
      value: {
        ja: '機関・施設情報',
        en: 'Institutions and facilities'
      },
      equivalence: [
        '機関・施設情報'
      ]
    },
    {
      code: 'other',
      value: {
        ja: 'その他',
        en: 'Others'
      },
      equivalence: [
        '構成要素',
        '記述情報',
        'コレクション',
        '画像要素'
      ]
    },
    {
      code: 'dataset',
      value: {
        ja: 'データセット',
        en: 'Data set'
      },
      equivalence: [
        'データセット'
      ]
    }
  ]
})
export const CODE_RIGHTS_GROUP: Code = Object.freeze({
  id: 'jps-rights_group',
  name: {
    ja: '権利区分グループ',
    en: 'Rights Group'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'edu',
      value: {
        ja: '教育利用',
        en: 'Educational'
      },
      equivalence: [
        'cc0',
        'pdm',
        'ccby',
        'ccbysa',
        'ccbync',
        'ccbyncsa',
        'incr_edu'
      ]
    },
    {
      code: 'noncom',
      value: {
        ja: '非商用利用',
        en: 'Non-commercial'
      },
      equivalence: [
        'cc0',
        'pdm',
        'ccby',
        'ccbysa',
        'ccbync',
        'ccbyncsa'
      ]
    },
    {
      code: 'com',
      value: {
        ja: '商用利用',
        en: 'Commercial'
      },
      equivalence: [
        'cc0',
        'pdm',
        'ccby',
        'ccbysa'
      ]
    }
  ]
})
export const CODE_RIGHTS_TYPE: Code = Object.freeze({
  id: 'jps-rights_type',
  name: {
    ja: '権利区分',
    en: 'Rights Type'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'cc0',
      value: {
        ja: 'CC0',
        en: 'CC0'
      },
      description: {
        ja: '著作権法上認められる、その者が持つ全ての権利（著作権に関連・隣接する権利を含む。）を、法令上認められる最大限の範囲で放棄して、パブリックドメインに提供していることを意味します。',
        en: 'The person/organization who associated a work with this deed has dedicated the work to the public domain by waiving all of his or her rights to the work worldwide under copyright law, including all related and neighboring rights, to the extent allowed by law.'
      }
    },
    {
      code: 'pdm',
      value: {
        ja: 'PDM',
        en: 'PDM'
      },
      description: {
        ja: '著作権による制限がなく、自由に利用可能であることを意味します。',
        en: 'This symbol denotes that a work is freely available without limitation by copyright.'
      }
    },
    {
      code: 'ccby',
      value: {
        ja: 'CC BY（表示）',
        en: 'CC BY'
      },
      description: {
        ja: '原作者のクレジット（氏名、作品タイトルなど）を表示することを主な条件とし、改変はもちろん、営利目的での二次利用も許可されるライセンス。',
        en: 'This license with the highest degree of freedom, with the main condition being to credit (name, title of the work, etc.) the original author; It also allows modification of the work, as well as secondary use for profit.'
      }
    },
    {
      code: 'ccbysa',
      value: {
        ja: 'CC BY-SA（表示—継承）',
        en: 'CC BY-SA'
      },
      description: {
        ja: '原作者のクレジット（氏名、作品タイトルなど）を表示し、改変した場合には元の作品と同じライセンスで公開することを主な条件に、営利目的での二次利用も許可されるライセンス。',
        en: 'License permitting secondary use for profit by displaying credit to the original author, and when modifying the work, public release under the same license as the original work being the main condition.'
      }
    },
    {
      code: 'ccbynd',
      value: {
        ja: 'CC BY-ND（表示—改変禁止）',
        en: 'CC BY-ND'
      },
      description: {
        ja: '原作者のクレジットを表示し、かつ元の作品を改変しないことを主な条件に、営利目的での利用（転載、コピー、共有）が行えるライセンス。',
        en: 'License that allows use (reprinting, copying, sharing) for commercial purposes with the main prerequisite being that original credits are displayed and the original work is not modified.'
      }
    },
    {
      code: 'ccbync',
      value: {
        ja: 'CC BY-NC（表示—非営利）',
        en: 'CC BY-NC'
      },
      description: {
        ja: '原作者のクレジット（氏名、作品タイトルなど）を表示し、かつ非営利目的であることを主な条件に、改変したり再配布したりすることができるライセンス。',
        en: 'License that allows modification and redistributions as long as credit to the original author is displayed with the main condition being that for it is non-profit purposes.'
      }
    },
    {
      code: 'ccbyncsa',
      value: {
        ja: 'CC BY-NC-SA（表示—非営利—継承）',
        en: 'CC BY-NC-SA'
      },
      description: {
        ja: '原作者のクレジット（氏名、作品タイトルなど）を表示し、かつ非営利目的に限り、また改変を行った際には元の作品と同じ組み合わせのライセンスで公開することを主な条件に、改変したり再配布したりすることができるライセンス。',
        en: 'License that allows modification and redistribution of a work as long as credit to the original author is displayed and is limited to non-profit purposes, and when modifying a work allows for its modification or redistribution under the main condition that it is released with the same combination of licenses as the original work.'
      }
    },
    {
      code: 'ccbyncnd',
      value: {
        ja: 'CC BY-NC-ND（表示—非営利—改変禁止）',
        en: 'CC BY-NC-ND'
      },
      description: {
        ja: '原作者のクレジット（氏名、作品タイトルなど）を表示し、かつ非営利目的であり、そして元の作品を改変しないことを主な条件に、作品を自由に再配布できるライセンス。',
        en: 'License that allows free redistribution for non-commercial purposes with the main prerequisite being that original credits are displayed and the original work is not modified.'
      }
    },
    {
      code: 'incr',
      value: {
        ja: '著作権あり',
        en: 'IN COPYRIGHT'
      },
      description: {
        ja: '著作権や関連する権利で保護されており、二次利用に当たっては著作権者の許諾が必要です。公開した者自身が著作権者である場合、著作権者から利用許諾を得ている場合、又は何らかの権利制限規定のもとで利用・提供している場合があります。',
        en: 'Requires permission from the copyright owner for secondary use. The work may be available for use in the event the publisher himself is the copyright holder, in the event the license has been obtained from the copyright holder, or under any other copyright restriction provisions.'
      }
    },
    {
      code: 'incr_edu',
      value: {
        ja: '著作権あり-教育目的の利用可',
        en: 'IN COPYRIGHT-EDUCATIONAL USE PERMITTED'
      },
      description: {
        ja: '著作権で保護されているものの、著作権者により、教育目的の利用が明示的に認められています（なお、本表記の有無に関わらず、著作権法第35条などの権利制限規定による利用は可能です）。',
        en: 'Educational use is permitted by the copyright owner despite the subsistence of copyrights.'
      }
    },
    {
      code: 'nocr_cont',
      value: {
        ja: '著作権なし-契約による制限あり',
        en: 'NO COPYRIGHT-CONTRACTUAL RESTRICTIONS'
      },
      description: {
        ja: '著作権や関連する権利による保護はありませんが、作品の公開者が、作品の取得やデジタル化に際して契約上、第三者による利用に制限を課すことが求められています。契約内容は個別に問合せする必要があります。',
        en: 'Although there are no restriction of the copyright and/or related righats, some restrictions to third party use are imposed by contract at the timie of acquisition or digitization.  Inquiries about the contract conditions must be made on an individual basis.'
      }
    },
    {
      code: 'nocr_other',
      value: {
        ja: '著作権なし-他の法的制限あり',
        en: 'NO COPYRIGHT-OTHER KNOWN LEGAL RESTRICTIONS'
      },
      description: {
        ja: '著作権や関連する権利による保護はありませんが、文化財や伝統的文化表現の保護等、他の法的制限により自由な利用ができません。制限の詳細は個別に確認する必要があります。',
        en: 'Although the copyright has already lapsed, free use is restricted due to other legal restrictions such as cultural heritage or traditional cultural expression protections.'
      }
    },
    {
      code: 'uneval',
      value: {
        ja: '著作権未評価',
        en: 'COPYRIGHT NOT EVALUATED'
      },
      description: {
        ja: '著作権の状態を判断するための調査が完了しておらず、著作権の状態が不明です。',
        en: 'Investigation to determine the status of copyright has not been completed and its copyright status remains unknown.'
      }
    },
    {
      code: 'undet',
      value: {
        ja: '著作権未決定-裁定制度利用著作物',
        en: 'COPYRIGHT UNDETERMINED-ORPHAN WORK in JAPAN'
      },
      description: {
        ja: '著作権者不明等のため裁定制度を利用して提供された著作物です。相当の努力を払って捜索しても著作権者と連絡することができない場合は、文化庁長官の裁定を受け、かつ、長官が定める額の補償金を供託することにより、適法に著作物を利用することができます。',
        en: 'Because the copyright is unknown (orphan work), the work is provided  in accordance with compulsory license system undet the Jpananese copyright law.'
      }
    },
    {
      code: 'others',
      value: {
        ja: '該当なし',
        en: 'Not applicable'
      },
      description: {
        ja: 'ジャパンサーチで設定可能な権利区分のいずれにも当てはまりません。',
        en: 'Not applicable to copyright notation marks provided by Japan Search'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'others',
      value: {
        ja: '該当なし',
        en: 'Not applicable'
      },
      description: {
        ja: 'ひなぎくで設定可能な権利区分のいずれにも当てはまりません。',
        en: 'Not applicable to copyright notation marks provided by HINAGIKU'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'various',
      value: {
        ja: 'コンテンツによって権利区分が異なる',
        en: 'Copyrights is differ in each contents.'
      },
      description: {
        ja: '',
        en: ''
      }
    }
  ]
})
export const CODE_SEARCH_CONTENTS_TYPE: Code = Object.freeze({
  id: 'jps-search_contents_type',
  name: {
    ja: 'コンテンツ検索',
    en: 'Access to Digital Contents'
  },
  type: 'SYSTEM',
  values: [
    {
      code: 'internet',
      value: {
        ja: 'ウェブ公開',
        en: 'Web'
      }
    },
    {
      code: 'restricted',
      value: {
        ja: '限定公開',
        en: 'Restricted'
      },
      system: [
        'jps'
      ]
    },
    {
      code: 'restricted',
      value: {
        ja: 'NDL館内限定公開',
        en: 'Available only at the NDL'
      },
      system: [
        'hina'
      ]
    },
    {
      code: 'not_exist',
      value: {
        ja: 'デジタルコンテンツなし',
        en: 'Not Exist'
      }
    },
    {
      code: 'various',
      value: {
        ja: 'コンテンツによってアクセス可能性が異なる',
        en: 'Accessibility is different in each content'
      }
    }
  ]
})
export const SYSTEM_CODES: Code[] = [
  CODE_CONTENTS_ACCESS,
  CODE_CURATION_TOPIC_CATEGORY,
  CODE_DB_CATEGORY,
  CODE_DIGITAL_CONTENTS_TYPE,
  CODE_FACET_RIGHTS_TYPE,
  CODE_ITEM_API_TYPE,
  CODE_LANGUAGE,
  CODE_RDF_TYPE,
  CODE_RIGHTS_GROUP,
  CODE_RIGHTS_TYPE,
  CODE_SEARCH_CONTENTS_TYPE
]
